import type { FormFieldType } from "./field.enums.ts";

export type FormFieldRenderPlacement = "layout" | "hidden";

export type FormFieldCapabilities = {
  readonly acceptsInput: boolean;
  readonly persistValue: boolean;
  readonly renderPlacement: FormFieldRenderPlacement;
};

export type FormFieldCapabilityRegistry = {
  readonly [T in FormFieldType]: FormFieldCapabilities;
};

const inputFieldCapabilities: FormFieldCapabilities = {
  acceptsInput: true,
  persistValue: true,
  renderPlacement: "layout",
};

// Confirm participates as an input but never persists its duplicate answer.
const confirmFieldCapabilities: FormFieldCapabilities = {
  acceptsInput: true,
  persistValue: false,
  renderPlacement: "layout",
};

// Content is display-only: it neither accepts nor persists an answer.
const contentFieldCapabilities: FormFieldCapabilities = {
  acceptsInput: false,
  persistValue: false,
  renderPlacement: "layout",
};

// Hidden accepts and persists an untrusted string, rendered outside the layout.
const hiddenFieldCapabilities: FormFieldCapabilities = {
  acceptsInput: true,
  persistValue: true,
  renderPlacement: "hidden",
};

// Type-owned behavior, not settings accepted from form authors or submission payloads.
export const formFieldCapabilities: FormFieldCapabilityRegistry = {
  TEXT: inputFieldCapabilities,
  EMAIL: inputFieldCapabilities,
  NUMBER: inputFieldCapabilities,
  PHONE: inputFieldCapabilities,
  WEBSITE: inputFieldCapabilities,
  CHECKBOX: inputFieldCapabilities,
  CHECKBOX_GROUP: inputFieldCapabilities,
  RADIO_GROUP: inputFieldCapabilities,
  SELECT: inputFieldCapabilities,
  DATETIME: inputFieldCapabilities,
  HIDDEN: hiddenFieldCapabilities,
  CONFIRM: confirmFieldCapabilities,
  CONTENT: contentFieldCapabilities,
};
